import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0493 2.33478C16.4957 1.88841 17.2206 1.88841 17.667 2.33478C18.1134 2.78116 18.1134 3.50608 17.667 3.95246L11.6177 9.99821L17.6634 16.0475C18.1098 16.4939 18.1098 17.2188 17.6634 17.6652C17.217 18.1116 16.4921 18.1116 16.0457 17.6652L9.99998 11.6159L3.95066 17.6616C3.50428 18.108 2.77936 18.108 2.33298 17.6616C1.8866 17.2153 1.8866 16.4903 2.33298 16.044L8.38231 9.99821L2.33655 3.94889C1.89018 3.50251 1.89018 2.78116 2.33655 2.33478C2.78293 1.88841 3.50785 1.88841 3.95423 2.33478L9.99998 8.38054L16.0493 2.33478Z",
		fill: "#0D2976"
	})
});
export default SvgCross;
